// extracted by mini-css-extract-plugin
export default {"link":"tF-z","disabled":"uF-z"};